export enum MediaTypeEnum {
    Filter = 0,
    SorbentTube = 1,
    PassiveBadge = 2,
    Impinger = 3,
    Colorimetric = 4,
    DetectorTubes = 5,
    WipeSamples = 6,
    Urine = 7,
    Blood = 8,
    ExhaledBreath = 9
}
